import React, {useEffect} from "react";
import styled from "styled-components";
import { shallowEqual, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";

import { withStyles } from "@material-ui/core/styles";
import { LinearProgress } from "@material-ui/core";

import CircledCheckIcon from "../assets/circle-check-extended.svg";
import IBTIcon from "../assets/instant-bank-transfer-plaid-mazooma.svg";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
`;

const CircledCheckImage = styled.img`
  height: 64px;
  padding-top: 64px;
  margin-right: auto;
`;

const Header = styled.div`
  padding: 16px 0;
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  color: #009245;
`;

const Note = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.4000000059604645px;
  text-align: left;
  color: #0000008A;
`;

const FooterWrapper = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const useStyles = makeStyles({
  linearProgress: {
    width: "50%",
    marginTop: "16px",
  },
});

const StyledLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#8B919A60',
  },
  barColorPrimary: {
    backgroundColor: "#8B919A"
  }
})(LinearProgress);

const RFPLiteSuccessPage = () => {
  const classes = useStyles();
  const appStore = useSelector((state) => state, shallowEqual).app;
  const { merchantName, merchantReturnUrl } = appStore;
  const redirectDelay = 3000;

  // Redirect to merchantReturnUrl after three seconds
  useEffect(() => {
    const interval = setTimeout(() => {
      window.location.href = merchantReturnUrl;
    }, redirectDelay);
    return () => clearTimeout(interval);
  }, [merchantReturnUrl, redirectDelay])

  return (
    <PageWrapper>
      <CircledCheckImage src={CircledCheckIcon} alt={CircledCheckIcon} />
      <Header>Thanks for completing your deposit!</Header>
      <Note>You're being redirected to {merchantName}</Note>
      <StyledLinearProgress className={classes.linearProgress} />
      <FooterWrapper>
        <Note>Thanks for using:</Note>
        <img src={IBTIcon} alt={IBTIcon} />
      </FooterWrapper>
    </PageWrapper>
  );
}

RFPLiteSuccessPage.propTypes = {};
RFPLiteSuccessPage.defaultProps = {};

export default RFPLiteSuccessPage;